import { useState, useEffect } from "react";
import fleetApi, { fleetError } from "@/lib/fleetApi";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Loader2 } from "lucide-react";

export default function AlertResolveDialog({ alert, open, onOpenChange, onResolved }) {
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setNote(""); }, [open]);

  const submit = async () => {
    setSaving(true);
    try {
      await fleetApi.post(`/alerts/${alert.id}/resolve`, { note: note.trim() });
      toast.success("Alert resolved.");
      onResolved?.(alert.id);
      onOpenChange(false);
    } catch (e) {
      toast.error(fleetError(e, "Couldn't resolve."));
    } finally { setSaving(false); }
  };

  if (!alert) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-slate-800 bg-[#0f172a] text-white" data-testid="alert-resolve-dialog">
        <DialogHeader>
          <DialogTitle>Resolve alert</DialogTitle>
          <p className="text-sm text-slate-400">{alert.problem}</p>
        </DialogHeader>
        <div>
          <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-slate-400">Resolution note (optional)</label>
          <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={3}
            placeholder="What was done? This is recorded in the audit log." data-testid="alert-resolve-note"
            className="border-slate-700 bg-slate-900 text-white placeholder:text-slate-500" />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} className="text-slate-300 hover:bg-slate-800 hover:text-white" data-testid="alert-resolve-cancel">Cancel</Button>
          <Button onClick={submit} disabled={saving} className="gap-2 bg-emerald-600 text-white hover:bg-emerald-700" data-testid="alert-resolve-confirm">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Resolve
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
